import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
} from '@material-ui/core';

import IconClose from 'src/assets/icons/Close';
import { useStyles } from './useStyles';

export const PopupInformation = ({
  open,
  title,
  content,
  confirm,
  onClose,
  alignCenter,
}) => {
  const styles = useStyles();

  return (
    <Dialog
      classes={{
        paper: cx(styles.paper, { [styles.alignCenter]: alignCenter }),
      }}
      open={open}
      onClose={onClose}
      data-testid="PopupInformation"
    >
      <DialogTitle className={styles.dialogTitle} disableTypography>
        <Typography className={styles.title} variant="h4">
          {title}
        </Typography>

        <IconButton className={styles.buttonClose} onClick={onClose}>
          <IconClose />
        </IconButton>
      </DialogTitle>

      {content && (
        <DialogContent className={styles.dialogContent}>
          <Typography className={styles.content} variant="body1">
            {content}
          </Typography>
        </DialogContent>
      )}

      <DialogActions className={styles.dialogActions}>
        <Button
          className={styles.buttonConfirm}
          onClick={onClose}
          variant="contained"
          color="primary"
          aria-label="Confirm"
        >
          {confirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PopupInformation.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  confirm: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  alignCenter: PropTypes.bool,
};

PopupInformation.defaultProps = {
  content: null,
  confirm: null,
  alignCenter: false,
};
